import { z } from "zod";

/**
 * An invoice's cost allocation as a person sets it: an amount per cost centre. The server checks
 * what the form cannot — that the amounts add up to the invoice's net amount and that every cost
 * centre is one of the organisation's active ones.
 */
export const incomingInvoiceCostAllocationSchema = z.object({
	allocations: z.array(
		z.object({
			costCenterId: z.uuid(),
			amount: z.number(),
		}),
	),
});

export type IncomingInvoiceCostAllocationSchema = z.infer<
	typeof incomingInvoiceCostAllocationSchema
>;

/**
 * The allocation form's rows: the schema's, plus each row's share of the net amount in percent,
 * which the form edits beside the amount and keeps in step with it. The route's schema drops the
 * share — only the amount is stored.
 */
export const incomingInvoiceCostAllocationFormSchema = z.object({
	allocations: z.array(
		z.object({
			costCenterId: z.uuid(),
			amount: z.number(),
			share: z.number(),
		}),
	),
});

export type IncomingInvoiceCostAllocationFormSchema = z.infer<
	typeof incomingInvoiceCostAllocationFormSchema
>;
